import Button from '@mui/material/Button'
import React from 'react'
import { useTranslation } from 'react-i18next'
import usePreference from '../../../../utils/preferences/usePreference'
import useBankAuthFlow from '../../../auth/components/useBankAuthFlow'

interface AuthenticateStepProps {
	redirectUri: string
}
export const AuthenticateStep: React.FC<AuthenticateStepProps> = ({ redirectUri }) => {
	const { t } = useTranslation('modals_moveOutContact')
	const [, setPostAuthRoute] = usePreference('postAuthRoute', null)
	const { startAuth } = useBankAuthFlow()

	const handleAuthenticate = () => {
		setPostAuthRoute(redirectUri)
		startAuth()
	}

	return (
		<div>
			<Button onClick={handleAuthenticate}>{t('authenticateStep.authenticate')}</Button>
		</div>
	)
}

export default AuthenticateStep
